module.exports = __webpack_public_path__ + "static/media/spinner.bf338ce7.gif";